module.exports = __webpack_public_path__ + "static/giftcard-open-e43087778561315dc44d4f4abd70b5a6.png";